import React, {useEffect} from "react";

const AdfitTermsDialog = ({close}) => {
  const handleClickOutside = (ev) => {
    if (ev.target === ev.currentTarget) {
      close();
    }
  };
  useEffect(() => {
    document.body.className = "scroll_hide";
    return () => {
      document.body.className = "";
    }
  }, []);
  return (
    <div className="container_layer" onClick={handleClickOutside}>
      <div className="blog_layer" style={{top: 'calc(50% - 230px)'}}>
        <div className="inner_blog_layer inner_blog_layer7">
          <div className="cont_layer">
            <strong className="tit_popup">AdFit 연동 안내</strong>
            <ul className="list_cont_layer">
              <li>
                <em className="tit_list">1. kakaoAdFit 정보 조회</em>
                <span className="txt_popup_type1">로그인한 AdFit 계정과 연동된 블로그의 광고 단위, 예상 적립금, 통계 정보 및 AdFit 계정의 확정 적립금을 조회해 티스토리에 표시합니다. </span>
              </li>
              <li>
                <em className="tit_list">2. 광고 설정</em>
                <span className="txt_popup_type1">로그인한 AdFit 계정의 매체에 등록된 광고를 티스토리 수익 메뉴에서 노출 여부를 설정할 수 있습니다. 단, 티스토리와 연동을 통한 광고만 설정 가능하고, 연동 완료 시 기존 플러그인은 설정 해제됩니다.</span>
              </li>
              <li>
                <em className="tit_list">3. 연동 해제 및 재연동</em>
                <span className="txt_popup_type1">연동 해제 및 재연동은 티스토리 수익 메뉴에서 언제든 할 수 있습니다. 단, AdFit 탈퇴나 규제 등의 이유로 연동이 해제됐을 경우 재연동이 불가능할 수 있습니다.</span>
              </li>
            </ul>
          </div>
          <div className="fld_btn">
            <button type="submit" className="btn_default" onClick={close}>확인</button>
          </div>
          <label className="lab_btn" onClick={close}>
            <span className="ico_blog">레이어 닫기</span>
            <input type="button" className="btn_g" value="닫기"/>
          </label>
        </div>
      </div>
    </div>
  )
};

export default AdfitTermsDialog;